import React from 'react';
import PropTypes from 'prop-types';
import Swiper, { SwiperArrowType } from '@deporvillage/swiper-component';
import {
    Config,
    I18nContext,
    formatPrice,
} from '@deporvillage/utils-library-component';

import styles from './TopHeader.module.scss';

const breakpoints = {
    0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        freeMode: false,
    },
};

const TopHeader = ({ showBestPrice, showFinance }) => {
    const [topHeader, setTopHeader] = React.useState(false);

    const { lang, freeDeliveryThreshold, store, country } =
        React.useContext(Config);
    const { translate } = React.useContext(I18nContext);
    const isFreeDelivery = freeDeliveryThreshold && store.code === country.code;

    const swiperItems = [
        {
            icon: 'icon-transport',
            title: isFreeDelivery
                ? translate('header.services.shipping_free', {
                    shipping_cost: formatPrice(
                        freeDeliveryThreshold,
                        country.currency_code,
                        lang,
                        {
                            decimalDigits: 0,
                            decimalPadding: 0,
                        }
                    ),
                })
                : translate('header.services.shipping_express'),
        },
        {
            icon: 'icon-schedule',
            title: translate(
                isFreeDelivery
                    ? 'header.services.express_delivery'
                    : 'header.services.delivery'
            ),
        },
        {
            title: translate('header.services.return'),
            icon: 'icon-refresh',
        },
    ];

    if (showFinance) {
        swiperItems.push({
            title: translate('header.services.finance'),
            icon: 'icon-credit-card',
        });
    } 

    if (showBestPrice) {
        swiperItems.push({
            title: translate('header.services.price'),
            icon: 'icon-tag',
        });
    }

    React.useEffect(() => {
        setTopHeader(true);
    }, []);

    return topHeader ? (
        <div
            className={styles['top-header-component']}
        >
            <div className={styles['header-services']}>
                <Swiper
                    breakpoints={breakpoints}
                    arrows={SwiperArrowType.None}
                    loop
                    disableOnInteraction
                    delay={4000}
                    autoplay
                >
                    {swiperItems.map(({ icon, title }, idx) => (
                        <div key={idx} className={ styles['header-services-wrapper']}>
                            <div className={styles['top-header-info']}>
                                <span className={`${styles['icon']} icon ${icon}`} />
                                <span
                                    dangerouslySetInnerHTML={{ __html: title }}
                                />
                            </div>
                        </div>
                    ))}
                </Swiper>
            </div>
        </div>
    ) : null;
};

TopHeader.propTypes = {
    showBestPrice: PropTypes.bool,
    showFinance: PropTypes.bool,
};

export default TopHeader;
